module.exports = __webpack_public_path__ + "img/blog-2.243947b7.webp";